import React from 'react';
import type { TrainingDay } from '../../types';
import styles from './DayView.module.css';

interface DayViewProps {
  day: TrainingDay;
}

export const DayView: React.FC<DayViewProps> = ({ day }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.dayName}>{day.day}</h3>
        <span className={styles.muscleGroup}>{day.muscleGroup}</span>
      </div>

      <div className={styles.exercises}>
        {day.exercises.map((exercise, idx) => (
          <div key={idx} className={styles.exercise}>
            <div className={styles.exerciseHeader}>
              <span className={styles.exerciseNumber}>{idx + 1}</span>
              <h4 className={styles.exerciseName}>{exercise.name}</h4>
            </div>
            
            <div className={styles.exerciseDetails}>
              <div className={styles.detail}>
                <span className={styles.detailLabel}>Sets</span>
                <span className={styles.detailValue}>{exercise.sets}</span>
              </div>
              <div className={styles.detail}>
                <span className={styles.detailLabel}>Rest</span>
                <span className={styles.detailValue}>{exercise.restSeconds}s</span>
              </div>
            </div>

            {exercise.tip && (
              <div className={styles.tip}>
                <span className={styles.tipLabel}>💡 Tip:</span>
                <span className={styles.tipText}>{exercise.tip}</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
